<template>
    <div class="layer-content common"
         style="height: 413px;overflow-y: scroll;">
        <div class="info2">
            <label><span class="box"></span>시/도 : </label>
            <select class="mgl5"
                    style="width: 150px;"
                    v-model="selSidoCode"
                    @change="sidoChange()">
                <option v-for="(sidoInfo,index) in sidoList"
                        :key="'sidoInfo' + index"
                        :value="sidoInfo.arcode">
                    {{sidoInfo.arname}}
                </option>
            </select>
            <label class="mgl10"><span class="box"></span>시/군/구 : </label>
            <select class="mgl5"
                    style="width: 150px;"
                    v-model="selSigunCode">
                <option v-for="(sigunInfo,index) in sigunList"
                        :key="'sigunInfo' + index"
                        :value="sigunInfo.arcode">
                    {{sigunInfo.arname}}
                </option>
            </select>
            <label class="mgl10"><span class="box"></span>원명 : </label>
            <input type="text"
                   ref="fcltNm"
                   class="mgl5"
                   style="width: 150px"
                   maxlength="14"
                   v-model="fcltNm"
                   @keyup.enter="btn_fcltSearchClick"/>
            <button class="middle _bt-gray mgl10" style="width:82px;" @click="btn_fcltSearchClick">
                <span>검색</span>
            </button>
            <div class="mgt15">운영 중인 원을 선택해주세요.</div>
        </div>
        <table class="tb-col mgt10">
            <colgroup>
                <col style="width:280px;">
                <col style="width:80px;">
                <col style="width:*">
                <col style="width:80px;">
            </colgroup>
            <thead>
            <th>어린이집명</th>
            <th>정원</th>
            <th>주소</th>
            <th class="last">선택</th>
            </thead>
            <tbody v-if="chilCareFcltList.length > 0">
            <tr v-for="(fcltInfo,index) in chilCareFcltList"
                :key="'chilCareFcltInfo' + index">
                <td style="text-align: left;">{{ fcltInfo.crname }}</td>
                <td>{{ fcltInfo.crcapat + '명' }}</td>
                <td style="text-align: left;">{{ fcltInfo.craddr }}</td>
                <td class="last">
                    <button class="small _bt-blue"
                            @click="btn_selChilCareFcltClick(fcltInfo)" >
                        <span>선택</span>
                    </button>
                </td>
            </tr>
            </tbody>
            <tbody v-if="chilCareFcltList.length == 0">
            <tr>
                <td colspan="4">조회된 내역이없습니다.</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: 'searchFclt_popup',
        props: ['index','param'],
        data: function(){
            return {
                selSidoCode:null,
                sidoList: new Array(),
                selSigunCode:null,
                sigunList: new Array(),
                fcltNm : '',
                chilCareFcltList: new Array(),
                callBackFunc : null,
                chilCareFcltInfo:{
                    ledgrNm:'',
                    stcode:'',
                    crname:'',
                    bizrno:'',
                    crtype:'',
                    crtypename:'',
                    crtel:'',
                    crfax:'',
                    craddr:'',
                    crcapat:''
                },
                selCallBackFunc: null
            }
        },
        methods: {
            sidoChange: function() {
                const _this = this;
                _this.sigunList = new Array();

                if(_this.selSidoCode!=null){
                    this.$onbiLib.searchSigunList(_this.selSidoCode).then(function(sigunList){
                        _this.selSigunCode = null;
                        _this.sigunList = _this.sigunList.concat([{arname:'선택해주세요',arcode:null}],sigunList);
                    });
                }else{
                    _this.selSigunCode = null;
                    _this.sigunList = _this.sigunList.concat([{arname:'시/도를 선택해주세요',arcode:null}]);
                }
            },
            btn_fcltSearchClick:function(){
                if (this.selSidoCode==null) {
                    this.$toasted.show('시/도를 선택해주세요.');
                    return;
                }
                if (this.selSigunCode==null) {
                    this.$toasted.show('시/군/구를 선택해주세요.');
                    return;
                }
                if (this.fcltNm==null||this.fcltNm.replace(/(\s*)/gi,'') == '') {
                    if(this.fcltNm.replace(/(\s*)/gi,'') == '') this.fcltNm = '';
                    this.$refs.fcltNm.focus();
                    this.$toasted.show('원명을 입력해주세요.');
                    return;
                }

                const _this = this;

                this.axios.post('/i5gam/srvc/searchChilCareFcltList.act',{
                    arcode : this.selSigunCode,
                    crname : this.fcltNm
                }).then(function(response) {
                    this.chilCareFcltList = response.data.chilCareFcltList;
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            btn_selChilCareFcltClick: function(fcltInfo){
                if(Number(fcltInfo.joinCnt) > 0){   //이미등록된 원 있으면 등록못하도록 수정
                    this.$store.commit('closePopup',this.index);
                    this.$store.commit('closePopup');

                    const popupInfo = {
                        se:'modal',
                        id:'searchFcltOvrlpPopup',
                        wid:'650',
                        hei:'',
                        tit:'원 중복 신청 안내 팝업',
                        draggableAt:false,
                    };
                    this.$store.commit('openPopup',popupInfo);
                    return;
                }else{
                    this.selCallBackFunc(fcltInfo,this.selSidoCode,this.selSigunCode);
                    this.$store.commit('closePopup',this.index);
                }
                //20200213 문욱제 보육통합 정보 조회 없이 선택가능하도록변경
                /*const _this = this;

                this.axios.post('/i5gam/srvc/searchChilCareFcltInfo.act',{
                    arcode : fcltInfo.arcode,
                    stcode : fcltInfo.stcode,
                }).then(function(response) {
                    this.selCallBackFunc(response.data.chilCareFcltInfo,this.selSidoCode,this.selSigunCode);
                    this.$store.commit('closePopup',this.index);
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });*/
            }
        },
        mounted: function() {
            const _this = this;

            const sidoCode  = this.param.sidoCode;
            const sigunCode = this.param.sigunCode;
            const fcltNm    = this.param.fcltNm;

            this.selCallBackFunc = this.param.selCallBackFunc;

            this.$onbiLib.searchSidoList().then(function(sidoList){
                _this.sidoList = _this.sidoList.concat([{arname:'선택해주세요',arcode:null}],sidoList);
                _this.selSidoCode = sidoCode;
                return _this.$onbiLib.searchSigunList(_this.selSidoCode);
            }).then(function(sigunList){
                _this.sigunList = new Array();
                _this.sigunList = _this.sigunList.concat([{arname:'선택해주세요',arcode:null}],sigunList);
                _this.selSigunCode = sigunCode;
                _this.fcltNm = fcltNm;

                _this.btn_fcltSearchClick();
            }).catch(function(e){
                console.log(e);
                _this.$toasted.show(_this.$onbiLib.msg.err.system);
            });
        }
    }
</script>

<style scoped>

</style>